module.exports = __webpack_public_path__ + "static/scindo-ad1a59b75381c3d9e7dffefa51e391c9.png";